<template>
  <main>
    <div class>
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-if="statusSchoolYear" #right-element>
              <router-link :to="{name: 'AjoutClasse'}" class="btn button btn-primary" :disabled="loading">
                <i class="icon-Add" />
                {{ $t("button.addClass") }}
              </router-link>
            </template>
            <template #left-element>
              <h3>{{ $t("title.listClass") }} ({{ total }})</h3>
            </template>
          </TopTemplate>
        </div>
      </div>
      <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else>
        <div v-if="noLevels" class="container-fluid empty-message card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearchClasse") }}</p>
          </div>
        </div>
        <div v-else class="table classe">
          <div class>
            <div class="row">
              <div class="classes-liste spec-classe">
                <div class="table">
                  <div class>
                    <div class="table__wrapper">
                      <table class="table__classes">
                        <thead>
                          <tr class="item_class">
                            <th class="col-md-4">{{ $t("classe.tab.name") }}</th>
                            <th class="col-md-8">{{ $t("classe.tab.nbStudent") }}</th>
                            <th class="col-md-3 text-center">
                              {{ $t("common.actions") }}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="(level, index) in levels.sort((a, b) => (a.name > b.name ? 1 : -1))" :key="index">
                            <td :class="'level-' + level.id" colspan="3" class="td_content_all col-md-4">
                              <div>
                                <table class="item_table_classes" width="100%">
                                  <thead>
                                    <tr class="item_level item_class">
                                      <td class="col-md-4" style="cursor: pointer; z-index: 9" @click="level.Active = !level.Active">
                                        <i
                                          v-if="level.classe.length"
                                          class="arrow down arrow-collapse"
                                          :class="[level.classe.length ? (level.Active ? 'toRotate' : '') : 'space-right']"
                                        />
                                        {{ level.name }}
                                      </td>
                                      <td />
                                      <td class="col-md-4 action" />
                                    </tr>
                                  </thead>
                                  <tbody v-if="level.Active">
                                    <tr v-for="classe in level.classe.sort((a, b) => (a.name > b.name ? 1 : -1))" :key="classe.id" class="item_class">
                                      <td class="col-md-4">
                                        <router-link
                                          :to="{
                                            name: 'DetailsClasse',
                                            params: {id: classe.id},
                                          }"
                                          class
                                        >
                                          {{ classe.name }}
                                        </router-link>
                                      </td>
                                      <td class="col-md-8" style="padding: 20px 60px">
                                        {{ classe.nb_students }}
                                      </td>
                                      <td class="col-md-3 text-center">
                                        <div style="height: 16px">
                                          <router-link
                                            :to="{
                                              name: 'DetailsClasse',
                                              params: {id: classe.id},
                                            }"
                                            class
                                          >
                                            <i class="icon-eyes">
                                              <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                                            </i>
                                          </router-link>

                                          <router-link
                                            v-if="statusSchoolYear"
                                            :to="{
                                              name: 'EditClasse',
                                              params: {id: classe.id},
                                            }"
                                            class
                                          >
                                            <i class="icon-edit-02">
                                              <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                                            </i>
                                          </router-link>
                                          <i v-if="statusSchoolYear" class="icon-trash" @click.prevent="deleteClass(classe.id)">
                                            <span class="tooltiptext">{{ $t("button.tooltip.delete") }}</span>
                                          </i>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="table__wrapper__pagination-wrapper">
                        <div class="pagination text-right">
                          <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import ClasseService from "../../services/classe.service";
import LevelsService from "../../services/levels.service";
import {mapGetters} from "vuex";

export default {
  name: "ClassList",
  components: {
    TopTemplate,
  },
  data() {
    return {
      loading: false,
      classes: [],
      levels: [],
      noLevels: false,
      pagination: {},
      last_page: null,
      total: 0,
      groupByType: [],
      params: {
        q: "",
        order: false,
        limit: 20,
        page: 1,
        sort: "created_at",
      },
      passageYears: null,
    };
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    statusSchoolYear() {
      return this.getPassageYears.status;
    },
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.passageYears = val.id;
        this.LevelsList();
      }
    },
  },
  mounted() {
    this.loading = true;
    if (this.getPassageYears.id) {
      this.passageYears = this.getPassageYears.id;
      this.LevelsList();
    }
    // this.ClassList();
  },
  methods: {
    scrollToByRef(id) {
      setTimeout(() => {
        let el = this.$el.getElementsByClassName("level-" + id)[0];
        el.scrollIntoView();
      }, 500);
    },
    LevelsList() {
      LevelsService.getAll({
        params: {
          order: this.params.order,
          limit: this.params.limit,
          sort: this.params.sort,
          school_year: this.passageYears,
        },
      })
        .then((response) => {
          this.levels = response.data.data;
          this.noLevels = this.levels.length === 0;
          this.levels = this.levels.map((obj, index) => {
            // this.total += obj.classe.length;

            if (localStorage.getItem("level") !== "null") {
              let id = parseInt(localStorage.getItem("level"));
              if (obj.id === id) {
                this.scrollToByRef(id);
                localStorage.setItem("level", null);
                return {...obj, Active: true};
              } else {
                return {...obj, Active: false};
              }
            } else {
              if (index === 0) {
                return {...obj, Active: true};
              } else {
                return {...obj, Active: false};
              }
            }
          });
          this.last_page = response.data.meta.last_page;
          this.total = response.data.nb_class;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getResults(page = null) {
      this.params.page = !page ? this.params.page : page;
      this.loading = true;

      LevelsService.getAll({
        params: {
          limit: this.params.limit,
          page: this.params.page,
          order: this.params.order,
          sort: this.params.sort,
          school_year: this.passageYears,
        },
      }).then(
        (response) => {
          this.levels = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    deleteClass(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm btn-primary",
          cancelButton: "btn btn-cancel btn-outline-primary",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteClass"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            ClasseService.delete(id)

              .then((response) => {
                console.log("Réponse réussie:", response); // Debug

                if (response.status === 200) {
                  console.log("Statut 200, affiche Swal"); // Debug
                  swalWithBootstrapButtons.fire(this.$t("common.classDeleted"), "", "success");
                  this.LevelsList();
                }
              })
              .catch((error) => {
                console.log("Erreur attrapée:", error); // Debug

                this.loading = false;
                if (error && error.response) {
                  if (error.response.status === 400) {
                    swalWithBootstrapButtons.fire({
                      title: "Suppression impossible!",
                      html: "Cette classe ne peut pas être supprimée car elle contient des élèves.",
                      icon: "error",
                    });
                  }
                }
              });
          }
        });
    },
  },
};
</script>
